import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_RED } from "../../../config/constants";

const Track8BRed = ({ state, workState, onLabelClick }) => (
	<g id="Track8BRed" transform="translate(1917.000000, 661.000000)" className="track">
		<path
			d="M0.637426803,0.663722336 L91.0188276,84.3666731 C97.7005571,90.5546771 105.196263,95.8009451 113.298071,99.9599852 L217.425612,153.413564 L217.425612,153.413564"
			id="line" stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
			strokeWidth={tracksWidth} strokeLinecap="round"/>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'Track8BRed')}
			coords="47.637427, 45.663722"
			text="8B"
			textCoordsX="10.0268555"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_RED)}
		/>
	</g>
);

Track8BRed.propTypes = trackPropTypes;

export default Track8BRed;
